import { ok, ResultAsync } from "neverthrow";
import * as oauth from "oauth4webapi";

const host = import.meta.env.VITE_APP_OAUTH_HOST;
const clientId = import.meta.env.VITE_APP_OAUTH_CLIENT;

const issuer = new URL(host);

export const as = await oauth
	.discoveryRequest(issuer, {
		algorithm: "oidc",
		[oauth.allowInsecureRequests]: import.meta.env.DEV,
	})
	.then((res) => oauth.processDiscoveryResponse(issuer, res));

export const client: oauth.Client = {
	client_id: clientId,
	token_endpoint_auth_method: "none",
};

export const redirectURI = `${window.location.origin}/login/callback`;

export const refreshToken = async () => {
	const result = await ResultAsync.fromPromise(
		oauth
			.refreshTokenGrantRequest(
				as,
				client,
				oauth.None(),
				localStorage.getItem("oauth.refresh_token") as string,
			)
			.then((res) => oauth.processRefreshTokenResponse(as, client, res)),
		(e) => new Error("Error while refreshing token", { cause: e }),
	);

	if (result.isErr()) {
		console.error(result);
		return result;
	}

	const {
		refresh_token: refreshToken,
		access_token: accessToken,
		id_token: idToken,
	} = result.value;

	const claims = oauth.getValidatedIdTokenClaims(result.value);

	localStorage.setItem("oauth.refresh_token", refreshToken as string);
	localStorage.setItem("oauth.access_token", accessToken);
	localStorage.setItem("oauth.id_token", idToken as string);
	localStorage.setItem("oauth.user", JSON.stringify(claims));

	return ok({ refreshToken, accessToken, idToken });
};
